import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import HomePage from "@/pages/HomePage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import LegalPage from "@/pages/LegalPage";
import PathologyDetailPage from "@/pages/PathologyDetailPage";
import PublicationsPage from "@/pages/PublicationsPage";
import RecherchePage from "@/pages/RecherchePage";
import ChapterPage from "@/pages/ChapterPage";
import SportsShoulderPage from "@/pages/SportsShoulderPage";
import ShoulderEmergencyPage from "@/pages/ShoulderEmergencyPage";
import ChirurgieEpauleMarseillePage from "@/pages/ChirurgieEpauleMarseillePage";
import SeoLandingPage from "@/pages/SeoLandingPage";
import { SEO_LANDINGS } from "@/lib/seoLandings";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <div className="App" data-testid="app-root">
            <BrowserRouter>
              <Header />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/pathologie/:slug" element={<PathologyDetailPage />} />
                <Route path="/publications" element={<PublicationsPage />} />
                <Route path="/recherche" element={<RecherchePage />} />
                <Route path="/recherche/:slug" element={<ChapterPage />} />
                <Route path="/epaule-du-sportif" element={<SportsShoulderPage />} />
                <Route path="/urgences-epaule" element={<ShoulderEmergencyPage />} />
                <Route path="/chirurgie-epaule-marseille" element={<ChirurgieEpauleMarseillePage />} />
                {SEO_LANDINGS.map((l) => (
                  <Route key={l.slug} path={`/${l.slug}`} element={<SeoLandingPage landing={l} />} />
                ))}
                <Route path="/mentions-legales" element={<LegalPage type="mentions" />} />
                <Route path="/confidentialite" element={<LegalPage type="confidentialite" />} />
                <Route path="/rgpd" element={<LegalPage type="rgpd" />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              <Footer />
              <StickyMobileCTA />
              <Toaster richColors position="top-center" />
            </BrowserRouter>
          </div>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
